import axios from "axios";
import Cookies from "js-cookie";

const BASE_URL = process.env.REACT_APP_BASE_URL;

// Создаем экземпляр axios с базовой конфигурацией
const axiosInstance = axios.create({
  baseURL: BASE_URL,
  withCredentials: true,
});

// Интерцептор для добавления токена авторизации в заголовки
axiosInstance.interceptors.request.use(
  (config) => {
    const token = Cookies.get("access_token");
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

// Функция для очистки всех данных аутентификации
const clearAuthData = () => {
  Cookies.remove("access_token");
  Cookies.remove("refresh_token");
  Cookies.remove("user_id");
  Cookies.remove("email");
  Cookies.remove("first_name");
  Cookies.remove("last_name");
  localStorage.removeItem("isAuthenticated");
};

// Интерцептор для обработки ошибок и обновления токена
axiosInstance.interceptors.response.use(
  (response) => response,
  async (error) => {
    const originalRequest = error.config;

    if (error.response?.status === 401 && !originalRequest._retry) {
      originalRequest._retry = true; // Предотвращаем повторный вызов интерцептора

      const refreshToken = Cookies.get("refresh_token");
      if (!refreshToken) {
        // Если refresh-токен отсутствует, очищаем все данные аутентификации
        clearAuthData();
        window.location.href = "/login";
        return Promise.reject(error);
      }

      try {
        // Обновляем токен
        const { data } = await axios.post(`${BASE_URL}/auth/token/refresh/`, {
          refresh: refreshToken,
        });

        const newAccessToken = data.access;
        Cookies.set("access_token", newAccessToken, {
          sameSite: 'None',
          secure: true,
        });
        originalRequest.headers.Authorization = `Bearer ${newAccessToken}`;
        return axiosInstance(originalRequest);
      } catch (refreshError) {
        // При ошибке обновления токена очищаем все данные аутентификации
        clearAuthData();
        window.location.href = "/login";
        return Promise.reject(refreshError);
      }
    }

    return Promise.reject(error);
  }
);

export default axiosInstance;
